import styled from 'styled-components';
import { flexCenter, inputPlaceholder, btnReset } from '../../helpers/style-helpers';

export const ChatWindowSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;

  .chw-topbar {
    padding: 0 8px 8px;
    border-bottom: 1px solid #f5f5f7;
  }

  .chw-chat {
    position: relative;
    flex-grow: 1;

    .chw-scrollable {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: auto;
      max-height: 100%;
      padding: 0 16px 36px;
      overflow: auto;
    }
  }

  .chw-bottom-bar {
    border-top: 1px solid #dcdde4;
    padding: 13px 10px 13px 20px;
  }

  .chw-loading {
    ${flexCenter}

    flex: 1;
    height: 100%;
    background: #fff;
  }
`;

export const ChatInputSC = styled.form`
  display: flex;
  align-items: flex-start;

  .ci-input {
    flex: 1;
    align-self: center;
  }

  textarea {
    ${inputPlaceholder('rgba(51, 61, 108, 0.4)')}

    display: block;
    width: 100%;
    border: none;
    outline: none;
    resize: none;

    &:focus,
    &:active,
    &:hover {
      outline: none;
      box-shadow: none;
    }
  }

  .ci-controls {
    ${flexCenter}

    width: 90px;
  }

  .ci-button {
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    margin-bottom: 0;

    &:hover {
      opacity: 0.8;
    }
  }

  .ci-button-grey {
    ${flexCenter}

    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(51, 61, 108, 0.1);
  }

  .ci-send img {
    width: 30px;
    height: 30px;
  }

  .ci-separator {
    background-color: #dcdde4;
    width: 2px;
    height: 40px;
    margin-left: 8px;
    margin-right: 3px;
  }

  .ci-attachment {
    input {
      width: 1px;
      height: 1px;
      visibility: hidden;
    }
  }
`;

export const ChatGroupTitleSC = styled.div`
  position: sticky;
  top: 0;
  font-size: 12px;
  color: rgba(51, 61, 108, 0.4);
  text-align: center;
  z-index: 999;
  line-height: 1;

  span {
    display: inline-block;
    background: #fff;
    padding: 8px 15px;
    border-radius: 15px;
  }
`;

export const ChatAttachmentPreviewSC = styled.div`
  position: relative;
  margin-top: 10px;
  display: inline-block;

  img.cap-preview {
    width: auto;
    height: 80px;
    border-radius: 8px;
  }

  .cap-name {
    padding-right: 15px;
    font-weight: bold;
    font-size: 16px;
  }

  .cap-delete {
    ${btnReset}
    ${flexCenter}

    width: 22px;
    height: 22px;
    background: #fff;
    position: absolute;
    top: -6px;
    right: -6px;
    border-radius: 50%;

    &:hover {
      opacity: 0.8;
    }

    img {
      width: 10px;
      height: 10px;
    }
  }
`;
